<template>
  <div :class="[$style.ctn, $style[mode]]">
    <SvgIcon
      :class="$style.icon" width="12"
      height="12"
      src="icon-sprite.svg#information"
    />
    <div :class="$style.content">
      <slot />
      <a v-if="fullReportLinkAtEnd" target="_blank" :href="root.general.fullAnalysis">
        <span>full report</span>
        <SvgIcon width="14" height="14" src="icon-sprite.svg#open_in_new" />
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: { SvgIcon },
  inject: ['root'],
  props: {
    fullReportLinkAtEnd: { type: Boolean, default: false },
    mode: {
      type: String,
      default: 'simple',
      validator: (value) => ['simple', 'head'].includes(value),
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  display: flex;
  @media print {
    display: none;
  }
}
.icon {
  width: 12px;
  height: 12px;
  flex: none;
}

.content {
  margin-left: 6px;
  font-weight: 500;
  font-size: 12px;
  color: #aaaeb5;
  a {
    text-decoration-line: underline;
    color: #00b0e8;
  }

  a {
    display: inline-flex;
    svg {
      margin-left: 4px;
    }
  }
}

.head {
  .icon {
    margin-top: 2px;
  }
  .content {
    margin-left: 4px;
    font-size: 14px;
    letter-spacing: 0.02em;
    color: rgba(63, 71, 87, 0.44);
  }
}
</style>
